
(function () {
  var root = document.documentElement;
  var current = null;
  var resizeObserver = 'ResizeObserver' in window
    ? new ResizeObserver(function (entries) {

        setOffset(entries[0].target.getBoundingClientRect().height);
      })
    : null;

  function setOffset(height) {
    root.style.setProperty('--gm-consent-banner-offset', Math.ceil(height || 0) + 'px');
  }

  function watch(banner) {
    current = banner;
    setOffset(banner.getBoundingClientRect().height);
    if (resizeObserver) resizeObserver.observe(banner);
  }

  function unwatch() {
    if (resizeObserver && current) resizeObserver.unobserve(current);
    current = null;
    setOffset(0);
  }

  var existing = document.getElementById('shopify-pc__banner');
  if (existing) watch(existing);

  new MutationObserver(function () {
    var banner = document.getElementById('shopify-pc__banner');
    if (banner && banner !== current) {
      watch(banner);
    } else if (!banner && current) {
      unwatch();
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
